export default __webpack_public_path__ + "static/7_20-435ce9e0ebaf4bcf5f168859988d4b09.png";